import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COMMON, LAYOUT, TYPOGRAPHY } from '../constants';
const Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-3sl1pp-0"
})(["", " ", " ", ""], COMMON, LAYOUT, TYPOGRAPHY);
Text.defaultProps = {
  caps: false,
  color: 'text.black',
  ellipsis: false,
  textSize: 2
};
Text.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...TYPOGRAPHY.propTypes,

  /** Set text transform uppercase */
  caps: PropTypes.bool,

  /** Set text to ellipsis on overflow */
  ellipsis: PropTypes.bool
};
Text.displayName = 'Text';
export default Text;